(function () {
    'use strict';

    if (window.lucide && typeof window.lucide.createIcons === 'function') return;

    const SPRITE_URL = (function () {
        const s = document.currentScript;
        return (s && s.dataset && s.dataset.sprite) || '/build/lucide-sprite.svg';
    })();

    const SVG_NS = 'http://www.w3.org/2000/svg';
    const XLINK_NS = 'http://www.w3.org/1999/xlink';
    const warned = {};

    function toSvg(placeholder) {
        const name = placeholder.getAttribute('data-lucide');
        if (!name) return null;

        const svg = document.createElementNS(SVG_NS, 'svg');
        svg.setAttribute('xmlns', SVG_NS);
        svg.setAttribute('width', '24');
        svg.setAttribute('height', '24');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '2');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');

        let cls = 'lucide lucide-' + name;
        for (const attr of placeholder.attributes) {
            if (attr.name === 'data-lucide') continue;
            if (attr.name === 'class') {
                cls += ' ' + attr.value;
                continue;
            }
            svg.setAttribute(attr.name, attr.value);
        }
        svg.setAttribute('class', cls);
        svg.setAttribute('data-lucide', name);

        const use = document.createElementNS(SVG_NS, 'use');
        use.setAttribute('href', SPRITE_URL + '#lucide-' + name);
        use.setAttributeNS(XLINK_NS, 'xlink:href', SPRITE_URL + '#lucide-' + name);
        svg.appendChild(use);

        if (!warned[name]) {
            warned[name] = true;
            if (!/^[a-z0-9]+(-[a-z0-9]+)*$/.test(name)) {
                console.warn('[lucide-shim] suspicious icon name:', name);
            }
        }
        return svg;
    }

    function createIcons() {
        const nodes = document.querySelectorAll('i[data-lucide]');
        for (const node of nodes) {
            const svg = toSvg(node);
            if (svg) node.replaceWith(svg);
        }
    }

    window.lucide = { createIcons: createIcons };
})();
